module.exports = __webpack_public_path__ + "assets/img/400px-DELTA_Electronics_Logo.0de4afbe.png";